<template>
  <ib-application setupSSO>
    <MarketCardForUnderlying
      :exchange="state.exchange"
      :underlyingConid="state.underlyingConid"
      :limit="state.limit"
      :size="state.size"
      :origin="state.origin"
      openExternalContracts
    />
  </ib-application>
</template>

<script setup lang="ts">
import { inject, reactive, watch } from 'vue';
import MarketCardForUnderlying from './MarketCardForUnderlying.vue';
import { ibWS } from '@ibgroup-tws-webapps/ib.utils';
import { usePositionsManager } from '@/composables/usePositionsManager';

ibWS.init('forecast.trader2');

interface ModuleProps {
  underlyingConid: string;
  exchange: string;
  limit?: number;
  size: 'large' | 'small';
  origin?: string;
  account?: string;
}

defineEmits<{
  'view-more': [];
}>();

const moduleProps = inject<ModuleProps>('moduleProps', {
  underlyingConid: '',
  exchange: '',
  limit: 2,
  size: 'small',
  origin: 'landing',
});

// Get account from module props and initialize positions
const accountFromProps = inject<string>('account', '');
usePositionsManager(() => accountFromProps || moduleProps.account);

const state = reactive({
  underlyingConid: '',
  exchange: '',
  limit: 2,
  size: 'small' as 'large' | 'small',
  origin: 'landing',
});

watch(
  () => moduleProps.underlyingConid,
  (underlyingConid) => {
    if (underlyingConid) {
      state.underlyingConid = underlyingConid;
    }
  },
  { immediate: true },
);

watch(
  () => moduleProps.exchange,
  (exchange) => {
    if (exchange) {
      state.exchange = exchange;
    }
  },
  { immediate: true },
);

watch(
  () => moduleProps.limit,
  (limit) => {
    if (limit !== undefined) {
      state.limit = limit;
    }
  },
  { immediate: true },
);

watch(
  () => moduleProps.size,
  (size) => {
    if (size) {
      state.size = size;
    }
  },
  { immediate: true },
);

watch(
  () => moduleProps.origin,
  (origin) => {
    if (origin) {
      state.origin = origin;
    }
  },
  { immediate: true },
);
</script>
